import React, { useRef, useContext } from 'react';
import { useColors } from '../hooks/useColors';
import { Chart as ChartJS, RadialLinearScale,PointElement, LineElement, Filler, Tooltip, Legend, } from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { GeneralContext } from '../context/GeneralContext';
import { useTranslation } from "react-i18next"

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

export const RadarChart = ({ puntuacionesEjes, calification }) => {
    const { setChartImage } = useContext(GeneralContext)
    const ref = useRef()
    const { getCalificationColorWithAlfa, getCalificationColor } = useColors()
    const { t } = useTranslation()

    const saveChartImage = () => {
        if (ref && ref.current && ref.current) {
            setChartImage(ref.current.toBase64Image('image/jpeg', 1))
        }
    }
var yLabels = {
    0: '-',
    25: t('Resultado.bajo'),
    50: t('Resultado.medioBajo'),
    75: t('Resultado.medioAlto'),
    100: t('Resultado.alto')
}
    const options = {
        plugins: {
            legend: {
                display: false
            },
            customCanvasBackgroundColor: {
                color: 'white',
            }
        },
        elements: {
            line: {
                borderWidth: '3'
            }
        },
        animation: {
            duration: 200,
            complete: saveChartImage
        },
        scale: {
            min: 0,
            max: 100,
        },
        scales: {
            r: {
                pointLabels: {
                    font: {
                        size: 16,
                    },
                },
                ticks: {
                    stepSize: 25,
                    callback: function (value, index, values) {
                        return yLabels[value];
                    },
                    color: ["000", getCalificationColor('D'), getCalificationColor('C'), getCalificationColor('B'), getCalificationColor('A')],
                    font: {
                        size: 20,
                    }
                },
            },
        }    }
    const plugin = [{
        id: 'customCanvasBackgroundColor',
        beforeDraw: (chart, args, options) => {
            const { ctx } = chart;
            ctx.save();
            ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = options.color || '#99ffff';
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
        }
    }];

    function strToArray(str, limit) {
        const words = str.split(' ')
        let aux = []
        let concat = []

        for (let i = 0; i < words.length; i++) {
            concat.push(words[i])
            let join = concat.join(' ')
            if (join.length > limit) {
                aux.push(join)
                concat = []
            }
        }

        if (concat.length) {
            aux.push(concat.join(' ').trim())
        }

        return aux
    }

    const data = {
        labels: puntuacionesEjes ? (puntuacionesEjes.map(p => strToArray(p.eje.texto, 6))) : (null),
        datasets: [
            {
                label: 'Cuestionario',
                data: puntuacionesEjes ? (puntuacionesEjes.map(p => p.puntuacion)) : (null),
                backgroundColor: getCalificationColorWithAlfa(calification, 0.2),
                borderColor: getCalificationColor(calification),
            }
        ],
    };

    return (
        <>
            <Radar ref={ref} options={options} data={data} plugins={plugin} />
        </>
    )
}